import { Box } from '@primer/react';
import {
  allImpactCategoryDataSources,
  DataSourceGroup,
  ImpactCategoryDataSource,
} from '@upright/common/model/input/data-sources/impact-category-data-sources';
import { toImpactCategoryId, UIImpactCategory } from '@upright/common/model/input/impacts/types';
import { Heading } from '@upright/ui/common/generic/components/primer-custom/heading';
import { Link } from '@upright/ui/common/generic/components/primer-custom/link';
import { Text } from '@upright/ui/common/generic/components/primer-custom/text';
import { groupBy } from 'lodash';

interface Props {
  category: UIImpactCategory;
}

export const BasisForCalculation = (props: Props) => {
  const id = toImpactCategoryId(props.category.code);
  const sourcesForCategory = allImpactCategoryDataSources.filter(source => source.impactCategories.includes(id));
  const groupedSources = groupBy(sourcesForCategory, c => c.group);

  return (
    <Box my={3}>
      <Heading fontSize="micro">Basis for calculation</Heading>
      <Text>
        <ul>
          {Object.values(groupedSources).map(sources => {
            return (
              <li key={sources[0].group}>
                {sources[0].group} {friendlySourceLinks(sources)}
              </li>
            );
          })}
        </ul>
      </Text>
    </Box>
  );
};

function friendlySourceLinks(sources: ImpactCategoryDataSource[]) {
  if (sources.every(source => !source.link)) {
    return <></>;
  }
  if (sources.length === 1) {
    const source = sources[0];
    return (
      <span>
        ({source.group === DataSourceGroup.CRITICAL_INFRASTRUCTURE && 'e.g. '}
        {source.link ? (
          <Link indicator="color" href={source.link}>
            {source.name}
          </Link>
        ) : (
          source.name
        )}
        )
      </span>
    );
  }
  if (sources[0].group === DataSourceGroup.PUBLIC) {
    return sources.map(
      (item, index) =>
        item.link && (
          <span key={item.name}>
            {index ? ' and ' : ''}
            <Link indicator="color" href={item.link} rel="noreferrer">
              {item.group === DataSourceGroup.PUBLIC ? item.name.toLowerCase() : item.name}
            </Link>
          </span>
        ),
    );
  }
  return (
    <span>
      (e.g.{' '}
      {sources.map(
        (item, index) =>
          item.link && (
            <span key={item.name}>
              {index ? ', ' : ''}
              <Link indicator="color" href={item.link} rel="noreferrer">
                {item.group === DataSourceGroup.PUBLIC ? item.name.toLowerCase() : item.name}
              </Link>
            </span>
          ),
      )}
      )
    </span>
  );
}
